import { useState } from 'react'
import { BoxArrowUpRight, Search } from 'react-bootstrap-icons'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import moustacheSvg from '../../assets/moustache.svg'
import pushchairSvg from '../../assets/pushchair.svg'
import { CustomButton } from '../../components/CustomButton'
import Navbar from '../../components/navbar/navbar'
import apinode from '../../services/apinode'
import { ModalChildren } from './ModalChildren'
import { ModalDad } from './ModalDad'
import { ContentProduct, Footer, Header, Main } from './ModalDad/styles'
import { Container, Input, InputGroup, Label, ResultView } from './styles'

export function ConsultarHeranca() {
  const [hierarchy, setHierarchy] = useState({})
  const [search, setSearch] = useState('')
  const [isSearchLoading, setSearchIsLoading] = useState(false)

  const [isModalChildrenOpen, setIsModalChildrenOpen] = useState(false)
  const [isModalDadOpen, setIsModalDadOpen] = useState(false)

  async function handleSearch() {
    try {
      setSearchIsLoading(true)

      const response = await apinode.get(
        `/consultar_heranca/${localStorage.idconta}?search=${search}`,
      )

      setHierarchy(response.data)
    } catch (err) {
      toast.error(
        err?.response?.data?.message || 'Não foi possível listar os itens!',
      )
    } finally {
      setSearchIsLoading(false)
    }
  }

  return (
    <>
      <Navbar />

      <Container className="mt-page">
        <h1>Consultar Herança de Produtos</h1>

        <Label>Digite o SKU</Label>

        <InputGroup>
          <Input
            placeholder="Digite aqui..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSearch()
              }
            }}
          />

          <CustomButton
            isLoading={isSearchLoading}
            onClick={handleSearch}
            styles={{
              height: 35,
            }}
          >
            <Search />
          </CustomButton>
        </InputGroup>

        <ResultView>
          {hierarchy?.product && (
            <ContentProduct>
              <Header>
                <h1>
                  CÓD: <strong>{hierarchy.product.codproduto}</strong> | SKU:{' '}
                  <strong>{hierarchy.product.sku}</strong>
                </h1>
              </Header>

              <Main>
                <h1>{hierarchy.product.descricao}</h1>
              </Main>

              <Footer>
                <CustomButton
                  onClick={() => setIsModalDadOpen(true)}
                  title="Ver Pai"
                  isDisabled={!hierarchy?.dad}
                >
                  <img src={moustacheSvg} />
                </CustomButton>

                <CustomButton
                  onClick={() => setIsModalChildrenOpen(true)}
                  title="Ver Filhos"
                  isDisabled={hierarchy?.children?.length === 0}
                >
                  <img src={pushchairSvg} />
                </CustomButton>

                <Link
                  target="_blank"
                  to={`/produtos/${hierarchy.product.codproduto}`}
                  style={{
                    textDecoration: 'none',
                  }}
                >
                  <CustomButton title="Editar">
                    <BoxArrowUpRight />
                  </CustomButton>
                </Link>
              </Footer>
            </ContentProduct>
          )}
        </ResultView>
      </Container>

      {isModalChildrenOpen && (
        <ModalChildren
          childrenData={hierarchy?.children}
          isOpen={isModalChildrenOpen}
          onClose={() => setIsModalChildrenOpen(false)}
        />
      )}

      {isModalDadOpen && (
        <ModalDad
          dad={hierarchy?.dad}
          isOpen={isModalDadOpen}
          onClose={() => setIsModalDadOpen(false)}
        />
      )}
    </>
  )
}
